<!-- @veltra/icons generated sha256:f13dbdb7518e43bc gen:8 source:src/svg/normal/message.svg -->
<script setup lang="ts">
defineOptions({ name: 'Message' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M1.499 3.999a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1zm11.599 0H2.9l4.538 3.025a1.02 1.02 0 0 0 1.122 0zm-10.599.934V12h11V4.933L8.545 8.236a.97.97 0 0 1-1.092 0z"
    />
  </svg>
</template>
